<template>
  <div 
    v-if="video && isYoutube" 
    class="video_contenedor" 
  >
    <!-- FIXME agregar código para controles personalizados -->
    <!-- FIXME agregar código para pausar el video al salir de pantalla -->
    <iframe 
      id="ytplayer"
      type="text/html"
      :width="width"
      :height="height"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
      allowfullscreen
      allowtransparency="true"
      :title="title"
      :src="videoSrc"
      class="p-0 max-h-full"
      :class="aspect == 'rectangular' ? 'aspect-video' : 'aspect-square' "
    >
    </iframe>  
  </div>
  <div 
    v-if="video && isVimeo" 
    class="video_contenedor" 
  >
    <iframe 
      id="vmplayer"
      type="text/html"
      width="100%"
      height="100%"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" 
      allowfullscreen
      :src="videoSrc"   
      :class="aspect == 'rectangular' ? 'aspect-video' : 'aspect-square' "    
    >
    </iframe>  
  </div>
  <div 
    v-if="video && !isVimeo && !isYoutube" 
    class="video_contenedor" 
  >
    <video
      :id="'video-'+id" 
      :src="videoSrc"
      :poster="portada"
      controlslist="nodownload"
      :muted="mute == '1' ? 'muted' : 'false'"
      :controls="controls"
      :autoplay="autoplay == '1' ? 'autoplay' : 'false'"
      disablePictureInPicture
      class="max-h-full"
      :class="aspect" 
    ></video>
  </div>
</template>

<script>
// TODO  al bajar y dejar de ver video, pausar y colocar imágen
export default {
  props: {
    video: {
      type: String,
      requiered: true,
      default: null
    },
    portada: {
      type: String,
      requiered: false,
      default: null
    },
    isYoutube: {
      type: Boolean,
      requiered: false,
      default: true
    },
    isVimeo: {
      type: Boolean,
      requiered: false,
      default: false
    },
    controls:{
      type: Number,
      requiered: false,
      default: 1 
    },
    mute:{
      type: Number,
      requiered: false,
      default: 1 
    },
    autoplay:{
      type: [Number, String],
      requiered: false,
      default: 0 
    },
    relvideos:{
      type: Number,
      requiered: false,
      default: 0 
    },
    playsline:{
      type: Number,
      requiered: false,
      default: 1 
    },
    byline:{
      type: Number,
      requiered: false,
      default: 0 
    },
    loop:{
      type: Number,
      requiered: false,
      default: 0 
    },
    color:{
      type: String,
      requiered: false,
      default: 'red' 
    },
    enableApi:{
      type: Number,
      requiered: false,
      default: 1 
    },
    istitle:{
      type: Number,
      requiered: false,
      default: 0 
    },
    title:{
      type: String,
      requiered: false,
      default: "YouTube Video" 
    },
    aspect:{
      type: String,
      requiered: false,
      default: "square" 
    },
    width:{
      type: String,
      requiered: false,
      default: "100%" 
    },
    height:{
      type: String,
      requiered: false,
      default: "100%" 
    },
    id:{
      type: [Number, String],
      requiered: false,
      default: "InstVideo" 
    }

  },
  emits:["onStop", "onPause", "onPlay"],
  data() {
    return {

    }
  },
  computed:{
    videoSrc() {
      let videoEditado 
      if (this.isYoutube){
        videoEditado = this.video.slice(17);
        //console.log(videoEditado)
        //`https://www.youtube.com/embed/${video}?controls=${controls}&mute=${mute}&autoplay=${autoplay}&modestbranding=1&rel=${relvideos}&loop=${loop}&color=${color}&playsinline=${playsline}&enablejsapi=${enableApi}`
        return `https://www.youtube.com/embed/${videoEditado}?controls=${this.controls}&mute=${this.mute}&autoplay=${this.autoplay}&modestbranding=1&rel=${this.relvideos}&loop=${this.loop}&color=${this.color}&playsinline=${this.playsline}&enablejsapi=${this.enableApi}`
      } else if(this.isVimeo){
        videoEditado = this.video.slice(18,27);
        // https://vimeo.com/802119092?share=copy
        //:src="video+`?controls=${controls}&muted=${mute}&autoplay=${autoplay}background=0&autopause=0&badge=0&rel=${relvideos}&loop=${loop}&color=${color}&enablejsapi=${enableApi}&playsinline=${playsline}&portrait=0&byline=${byline}&title=${istitle}`" 
        // 802119092
        //:src="video+`?controls=${controls}&muted=${mute}&autoplay=${autoplay}background=0&autopause=0&badge=0&rel=${relvideos}&loop=${loop}&color=${color}&enablejsapi=${enableApi}&playsinline=${playsline}&portrait=0&byline=${byline}&title=${istitle}`" 
        return `https://player.vimeo.com/video/${videoEditado}?controls=${this.controls}&mute=${this.mute}&autoplay=${this.autoplay}&modestbranding=1&rel=${this.relvideos}&loop=${this.loop}&color=${this.color}&playsinline=${this.playsline}&enablejsapi=${this.enableApi}`
      } else {
        return this.video
      }

    }
  },
  created() {
    //console.log(this.video);
    setTimeout(this.OnPlayVideo, 2000);
  },
  methods:{
    OnPlayVideo(){      
      let id = 'video-'+this.id;
      //console.log(id);
      document.getElementById(id).addEventListener('ended', this.OnEndedVideo, false);
      document.getElementById(id).addEventListener('pause', this.OnPauseVideo, false);
      document.getElementById(id).addEventListener('play', this.OnResumeVideo, false);
    },
    OnEndedVideo(){
      //console.log("fin")
      this.$emit("onStop", true)
    },
    OnPauseVideo(){
      //console.log("pause")
      this.$emit("onPause", true)
    },
    OnResumeVideo(){
      //console.log("play")
      this.$emit("onPlay", true)
    }
  }
}
</script>

<style>
  .video_contenedor{
    width: 100%;
    height: 100%;
  }
  .movil .video_contenedor{
    display: flex;
    justify-content: center;
  }
</style>